import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/payment-methods/new')({
  component: () => <Navigate replace to="/payment-methods" />,
})
